<app-school-details-form
  [initialData]="initialData"
  testIdPrefix="wizard-school-"
  schoolTypeTestId="wizard-school-type">
</app-school-details-form>
